import { AddOnDefinition, AddOns } from './../types';

const definition: AddOnDefinition = {
	addOn: AddOns.PACKAGE_PRODUCTS,
	blockSlots: 1,
};

export default definition;
